/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainEntitiesDocumentsDocumentContentContentType } from './FxIdDomainEntitiesDocumentsDocumentContentContentType';
import {
    FxIdDomainEntitiesDocumentsDocumentContentContentTypeFromJSON,
    FxIdDomainEntitiesDocumentsDocumentContentContentTypeFromJSONTyped,
    FxIdDomainEntitiesDocumentsDocumentContentContentTypeToJSON,
    FxIdDomainEntitiesDocumentsDocumentContentContentTypeToJSONTyped,
} from './FxIdDomainEntitiesDocumentsDocumentContentContentType';

/**
 * Представляет содержимое документа, состоящее из значения и его типа.
 * Является объектом-значением (Value Object).
 * @export
 * @interface FxIdDomainEntitiesDocumentsDocumentContent
 */
export interface FxIdDomainEntitiesDocumentsDocumentContent {
    /**
     * Значение (текст) содержимого.
     * @type {string}
     * @memberof FxIdDomainEntitiesDocumentsDocumentContent
     */
    Value: string;
    /**
     * 
     * @type {FxIdDomainEntitiesDocumentsDocumentContentContentType}
     * @memberof FxIdDomainEntitiesDocumentsDocumentContent
     */
    ContentType: FxIdDomainEntitiesDocumentsDocumentContentContentType;
}

/**
 * Check if a given object implements the FxIdDomainEntitiesDocumentsDocumentContent interface.
 */
export function instanceOfFxIdDomainEntitiesDocumentsDocumentContent(value: object): value is FxIdDomainEntitiesDocumentsDocumentContent {
    if (!('Value' in value) || value['Value'] === undefined) return false;
    if (!('ContentType' in value) || value['ContentType'] === undefined) return false;
    return true;
}

export function FxIdDomainEntitiesDocumentsDocumentContentFromJSON(json: any): FxIdDomainEntitiesDocumentsDocumentContent {
    return FxIdDomainEntitiesDocumentsDocumentContentFromJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsDocumentContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesDocumentsDocumentContent {
    if (json == null) {
        return json;
    }
    return {
        
        'Value': json['Value'],
        'ContentType': FxIdDomainEntitiesDocumentsDocumentContentContentTypeFromJSON(json['ContentType']),
    };
}

export function FxIdDomainEntitiesDocumentsDocumentContentToJSON(json: any): FxIdDomainEntitiesDocumentsDocumentContent {
    return FxIdDomainEntitiesDocumentsDocumentContentToJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsDocumentContentToJSONTyped(value?: FxIdDomainEntitiesDocumentsDocumentContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Value': value['Value'],
        'ContentType': FxIdDomainEntitiesDocumentsDocumentContentContentTypeToJSON(value['ContentType']),
    };
}

